// src/services/supabaseClient.ts
import { createClient } from '@supabase/supabase-js';

const supabaseUrl     = import.meta.env.VITE_SUPABASE_URL     as string | undefined;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined;

if (!supabaseUrl || !supabaseAnonKey ||
    supabaseUrl.includes('<your-project-ref>') ||
    supabaseAnonKey.includes('<your-anon-key>')) {
  throw new Error(
    '[QuiPus] Supabase env vars no configuradas.\n' +
    '→ Abre Supabase Dashboard → Settings → API\n' +
    '→ Copia el Project URL y anon key\n' +
    '→ Pégalos en el archivo .env del proyecto'
  );
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

/**
 * Asserts an active auth session and returns the authenticated user's ID.
 * This ID is used as `firmId` throughout the application.
 * Throws if no session is active.
 */
export async function requireAuth(): Promise<string> {
  const { data: { session }, error } = await supabase.auth.getSession();
  const user = session?.user;
  if (error || !user) throw new Error('No active session. Please log in.');
  return user.id;
}
